'use client';

import { useState } from 'react';
import i18n from '@shared/i18n';
import { CUSTOM_EVENT } from 'app/constants';

export interface UseSectionProps {
    usePositiveButton?: boolean;
    useNegativeButton?: boolean;
    positiveButtonContext?: string;
    negativeButtonContext?: string;
    initialDisabledButtons?: boolean;
}

export function useSection(props: UseSectionProps) {
    const {
        usePositiveButton: _usePositiveButton = true,
        useNegativeButton,
        positiveButtonContext: _positiveButtonContext,
        negativeButtonContext: _negativeButtonContext,
        initialDisabledButtons = false,
    } = props;

    const [isDataDispatching, setDataDispatching] = useState(false);

    const [disabledButtons, setDisabledButtons] = useState(initialDisabledButtons);

    const [usePositiveButton, setUsePositiveButton] = useState(_usePositiveButton);

    const positiveButtonContext = _positiveButtonContext || i18n.gettext('儲存');

    const negativeButtonContext = _negativeButtonContext || i18n.gettext('取消');

    function getPositiveEventName() {
        return CUSTOM_EVENT.SECTION_POSITIVE_BUTTON_HACKING_EVENT;
    }

    function getNegativeEventName() {
        return CUSTOM_EVENT.SECTION_NEGATIVE_BUTTON_HACKING_EVENT;
    }

    function handlePositiveButtonOnClick() {
        const positiveButtonOnClickEvent = new CustomEvent(getPositiveEventName());

        window.dispatchEvent(positiveButtonOnClickEvent);
    }

    function handleNegativeButtonOnClick() {
        const negativeButtonOnClickEvent = new CustomEvent(getNegativeEventName());

        window.dispatchEvent(negativeButtonOnClickEvent);
    }

    const state = {
        usePositiveButton,
        useNegativeButton,
        positiveButtonContext,
        negativeButtonContext,
        isDataDispatching,
        disabledButtons,
    };

    const actions = {
        setDataDispatching,
        setDisabledButtons,
        setUsePositiveButton,
        getPositiveEventName,
        getNegativeEventName,
        handlePositiveButtonOnClick,
        handleNegativeButtonOnClick,
    };

    return {
        state,
        actions,
    };
}

export type UseSectionType = ReturnType<typeof useSection>;
